import { useCallback } from 'react';
import useToast from '~/client/hooks/useToast';

const useQuickDeposit = () => {
  const { showToast } = useToast();

  const handleCopy = useCallback(
    (curr?: CashierCurrency) => {
      showToast({
        message:
          curr === 'XRP'
            ? 'cashier.destination_tag_copied'
            : 'general.address_copied',
        timeout: 6000,
        variant: 'success',
        position: 'bottom',
      });
    },
    [showToast],
  );

  return { handleCopy };
};

export default useQuickDeposit;
